import { useMemo } from 'react';

import InsightsTabsFilterBar from 'components/insights/filterBar/InsightsTabsFilterBar';
import FilterMultiSelect from 'components/shared/filters/FilterMultiSelect';
import {
  useInboundReferralsInsightsActions,
  useInboundReferralsInsightsStore,
} from 'stores/inboundReferralsInsightsStore';
import { FilterOption } from 'stores/types';

import { getFilterSections, SNF_DROPDOWN } from '../filters';

// The date range in the header plus the SNF filter (inline quick filter + slideout, both writing
// the same facility key) drive every query. The Referral Source and Payer filters ship alongside in
// the filter slideout (getFilterSections), OLIO-2999.
export default function InboundReferralsFilterBar() {
  const filters = useInboundReferralsInsightsStore((state) => state.filters);
  const { setSelectedFilters } = useInboundReferralsInsightsActions();

  const filterSections = useMemo(() => getFilterSections(), []);

  return (
    <InsightsTabsFilterBar
      title='Inbound Referral Dashboard'
      gtmPrefix='insightsInboundReferrals'
      filters={filters}
      filterSections={filterSections}
      setSelectedFilters={setSelectedFilters}
      quickFilter={
        <FilterMultiSelect
          {...SNF_DROPDOWN}
          value={filters[SNF_DROPDOWN.name] as FilterOption[]}
          // Debounce the commit like the list page's quick filter: every change fires a full round of
          // Insights requests, so rapid picks would otherwise fire a round per pick (OLIO-3564).
          debounceTime={500}
          onChange={(val) => setSelectedFilters({ [SNF_DROPDOWN.name]: val })}
        />
      }
    />
  );
}
